/**
 * The shared utils
 *
 * @copyright 2018 Linguistica 360
 */

import $ from 'jquery';

import { PROGRAM_URLS } from './config.js';

const urls = PROGRAM_URLS;

export function ucfirst(text) {
    return text[0].toUpperCase() + text.slice(1);
}

export function getConfig(key) {
    return window._NiSC[key];
}

export function resolveUrl(path, scope = 'local') {
    if (scope === 'local') scope = getConfig('scope');

    const root = getConfig('root');
    const scopeUrl = urls[scope] ? `${root}/${urls[scope]}/` : root;
    return `/${scopeUrl}/${path}`.replace(/\/+/g, '/');
}

export function resolveRoot(path) {
    return resolveUrl(path, 'root');
}

export function makeTooltips(text) {
    return text.replace(/{(.*?)=(.*?)}/g, (_, phrase, translation) => {
		translation = escapeAttribute(translation);

		if (/^\[(\d+)\]$/.test(translation)) {
			const episode = parseInt(translation.substr(1));
			const target = 'target="_blank"';
            const href = `episode/${episode}`;
			const ref = 'data-tooltip-reference="expressions"';

			return `<a ${ref} data-href="${href}" ${target}>${phrase}</a>`;
		}

        return `<span data-tooltip="${translation}">${phrase}</span>`;
    });
}

export function makeDialog(text) {
	const replace = '</td></tr><tr class="toprow"><td class="leftcol">$2:</td><td class="data">';
    text = text.replace(/(^|[\n\r])\s*([^:]+):/gi, replace);

	if (text.search('</td></tr>') === 0) text = text.substr(10) + '</td></tr>';
	return `<table class="dialog-table">${text}</table>`;
}

export function escapeHtml(unsafe) {
    return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

export function escapeAttribute(unsafe) {
    return unsafe.replace(/\\?"/g, '\\"');
}

export function $wrap(func, wrapJquery = true) {
    if (wrapJquery) return function (arg, arg1) { return func($(this), arg, arg1); };
    else return function (arg, arg1) { return func(this, arg, arg1); };
}

export function $val($element) {
    if (!($element instanceof $)) $element = $($element);
    if ($element.is(':checkbox')) return $element.is(':checked') ? 'on' : 'off';
    return $element.val();
}

export function makeQuery(url, params) {
    return `${url}?` + Object.keys(params).map((key) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
    }).join('&');
}

// money formatting
export function moneyFormat(amount, locale = 'en-US') {
    // 1. Sanitize the incoming value to ensure it's a valid number
    const cleanAmount = Number(amount) || 0;

    // 2. Initialize the native browser formatter
    const formatter = new Intl.NumberFormat(locale, {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return formatter.format(cleanAmount);
}

export function hasGroup(group) {
    return getConfig('groups').includes(group);
}

/** set localStorage with expiry, `ttl` in milliseconds */
export function setWithExpiry(key, value, ttl) {
    const now = new Date();

    const item = {
		value: value,
		expiry: now.getTime() + ttl,
	};

	localStorage.setItem(key, JSON.stringify(item));
}

/** get localStorage with expiry */
export function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
		return null;
	}

	const item = JSON.parse(itemStr);
	const now = new Date();

	if (now.getTime() > item.expiry) {
		localStorage.removeItem(key);
		return null;
	}

	return item.value;
}

const logoutLink = document.getElementById('logout-link');
if (logoutLink) {
    logoutLink.addEventListener('click', async (e) => {
       e.preventDefault();
       sessionStorage.clear();
       window.location.href = e.currentTarget.href;
    });
}

export const isMobile = window.matchMedia('(max-width: 768px)').matches;
